<template>
  <div>
    <div class="air__utils__heading">
      <h3>Multimedia</h3>
    </div>
    <div class="row">
      <div class="col-lg-12">

       <FileManager :folders="folders"/>

      </div>
    </div>
  </div>
</template>

<script>
import FileManager from './widgets/FileManager'
// import slidersRepository from './../../repository/slidersRepository'

export default {
  components: {
    FileManager,
  },
  data () {
    return {
      folders: [
        {
          id: 0,
          name: 'Nivea',
          url: '',
          childrens: [],
        },
        {
          id: 2,
          name: 'Bebes',
          url: '',
          childrens: [
            { id: 0, name: 'Pañales Huggies', imageUrl: 'https://lh3.googleusercontent.com/syIoNVWmAfkILaTxDJWiKlPeXajGkiyObCfFpKFw4icqv_IZOq9cbJGoXv41a-15A3AfXwU-UyFT890ZM2-F80oIR6KsmwKzKw' },
            { id: 1, name: 'Pañales Atom', imageUrl: 'https://lh3.googleusercontent.com/P2SDeowESl8htIbiKBZV5qODsbwE6GZK7Jd6er5vMx83cDaEaqFIEAGQcZRLRB-g5IhjyqXsK2XoyZP0Xvwr4yOQ8Jxh1LaZxg' },
            { id: 0, name: 'Pañales Huggies', imageUrl: 'https://lh3.googleusercontent.com/syIoNVWmAfkILaTxDJWiKlPeXajGkiyObCfFpKFw4icqv_IZOq9cbJGoXv41a-15A3AfXwU-UyFT890ZM2-F80oIR6KsmwKzKw' },
            { id: 1, name: 'Pañales Atom', imageUrl: 'https://lh3.googleusercontent.com/P2SDeowESl8htIbiKBZV5qODsbwE6GZK7Jd6er5vMx83cDaEaqFIEAGQcZRLRB-g5IhjyqXsK2XoyZP0Xvwr4yOQ8Jxh1LaZxg' },
            { id: 0, name: 'Pañales Huggies', imageUrl: 'https://lh3.googleusercontent.com/syIoNVWmAfkILaTxDJWiKlPeXajGkiyObCfFpKFw4icqv_IZOq9cbJGoXv41a-15A3AfXwU-UyFT890ZM2-F80oIR6KsmwKzKw' },
            { id: 1, name: 'Pañales Atom', imageUrl: 'https://lh3.googleusercontent.com/P2SDeowESl8htIbiKBZV5qODsbwE6GZK7Jd6er5vMx83cDaEaqFIEAGQcZRLRB-g5IhjyqXsK2XoyZP0Xvwr4yOQ8Jxh1LaZxg' },
          ],
        },
      ],
      folder: {},

      // Advertisings: []
    }
  },
  created() {
    // this.fetchSliderHome()
  },

}
</script>
